import React, { PropsWithChildren } from 'react';
import { Nullable } from 'global';
import FilterListIcon from '@mui/icons-material/FilterList';
import { TableFilter } from '@trnsact/trnsact-shared-types';
import { Button, FormGroup, FormControlLabel, Switch, Paper } from '@mui/material';
import { ExportButton } from 'components/shared/ExportButton';

import { FinanceListTabs } from '../../types';

interface Props {
  filtersAmount: number;
  currentTabValue: string;
  onFiltersClick: VoidFunction;
  onExportClick: VoidFunction;
  onSetAsDefaultClick: VoidFunction;
  isExportInProgress: boolean;
  defaultFilter?: Nullable<TableFilter>;
  isSetDefaultTableFilterLoading: boolean;
}

export const FinanceTabsWrapper = ({
  children,
  defaultFilter,
  filtersAmount,
  onFiltersClick,
  onExportClick,
  currentTabValue,
  isExportInProgress,
  onSetAsDefaultClick,
  isSetDefaultTableFilterLoading,
}: PropsWithChildren<Props>) => {
  const isCurrentTabDefault = defaultFilter?.tableFilterId === currentTabValue;
  const isCurrentTabStandard = (Object.values(FinanceListTabs) as string[]).includes(currentTabValue);

  return (
    <Paper elevation={0} sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        onClick={onFiltersClick}
        startIcon={<FilterListIcon />}
        sx={{ marginRight: '1rem', whiteSpace: 'nowrap' }}
      >
        {`Filters ${filtersAmount}`}
      </Button>

      <ExportButton
        label="Export view"
        variant="outlined"
        onClick={onExportClick}
        isLoading={isExportInProgress}
        sx={{ marginRight: '1rem', whiteSpace: 'nowrap' }}
      />

      {children}

      {!isCurrentTabStandard && (
        <FormGroup sx={{ marginLeft: 'auto' }}>
          <FormControlLabel
            label="Set as Default Tab"
            control={
              <Switch
                onClick={onSetAsDefaultClick}
                checked={isCurrentTabDefault}
                disabled={isSetDefaultTableFilterLoading}
              />
            }
          />
        </FormGroup>
      )}
    </Paper>
  );
};
